import React, { useEffect, useRef, useState } from "react";
import { Button, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { getFileManagersById } from "components/axios/fileManagerAxios";
import FileDownloadIcon from "components/FileDownloadIcon";
import { fileAccepts } from 'data/data';
import { useEnumApi } from "contexts/EnumApiContext";
import FileViewer from "components/FileViewer";
import { useTranslation } from "react-i18next";

const EquipmentDataView = ({ selectedId, onGoBack }) => {
    const { t } = useTranslation();
    const { getEnumValueByEnumNameAndCode } = useEnumApi();

    const printRef = useRef(null);

    const [accept, setAccept] = useState({});
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if(!isLoading && selectedId) {
            getFileManagersById(selectedId).then((data)=>{
                setData(data);
                return data;
            }).then((res2)=>{
                if (res2.attachedFiles && res2.attachedFiles.length > 0) {
                    const extension = res2.attachedFiles[0].originFile.substring(res2.attachedFiles[0].originFile.lastIndexOf("."));
                    const accept = fileAccepts.filter(item => item.extension.indexOf(extension) !== -1);
                    setAccept(accept[0]);
                }
            })
            setIsLoading(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[isLoading, 
]);

    if (isLoading && data) {
        return (
    <div>
        <TableContainer>
          <Table sx={{ minWidth: 600 }} aria-label="simple table" style={{borderTop:"2px solid #a2a2a2"}} >
            <TableBody>
              <TableRow>
                <TableCell className="th" style={{height:"65px"}}>{t('message.common.subtitle.equipment.level1')}</TableCell>
                <TableCell className="email_pl">{data?.equipmentCtgr?.parent?.name ?? ''}</TableCell>
                <TableCell className="th">{t('message.common.subtitle.equipment.level2')}</TableCell>
                <TableCell className="email_pl">{data?.equipmentCtgr?.name ?? ''}</TableCell>
                <TableCell className="th">{t('message.common.select.division')}</TableCell>
                <TableCell className="email_pl">{getEnumValueByEnumNameAndCode("FileType", data?.fileType)?.[0]?.title ?? ''}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="th">{t('message.common.subtitle.title')}</TableCell>
                <TableCell colSpan={3} className="email_pl">{data?.title ?? ''}</TableCell>
                <TableCell className="th">{t('message.common.subtitle.type2')}</TableCell>
                <TableCell className="email_pl">{data && accept && (accept.title || '')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="th">{t('message.common.subtitle.file')}</TableCell>
                <TableCell colSpan={5} className="email_pl">
                    <div style={{display:"flex"}}>
                        <FileDownloadIcon file={data.attachedFiles[0]} viewFileName={true} fontColor="#000" />
                    </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>

          {data.attachedFiles?.length > 0 &&
          <Table sx={{ minWidth: 600 }} aria-label="simple table" style={{borderTop:"2px solid #a2a2a2",marginTop:"10px"}} >
            <TableBody>
              <TableRow>
                <TableCell className="th">{t('message.common.subtitle.view.detail')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <FileViewer file={data.attachedFiles[0]} ref={ printRef } />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          }
        </TableContainer>

      <div className="btn_right" style={{justifyContent:"space-between"}}>
        <div><Button variant="contained" color="primary" onClick={onGoBack} style={{backgroundColor:"#333"}}>{t('message.common.btn.list')}</Button></div>
      </div>
    </div>
        )
    }
}

export default EquipmentDataView;